import * as React from "react";
import "./tab.component.css";
import { useEffect, useState, useMemo } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconActivity,
  IconCalendar,
  IconEdit,
  IconHandStop,
  IconLockDown,
  IconLockOpen,
  IconPlus,
  IconSearch,
  IconStatusChange,
  IconTimeDuration15,
  IconTrash,
  IconUserCode,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  GridCol,
  Input,
  rem,
  Select,
  Text,
  Tooltip,
} from "@mantine/core";

import { SelectListItem } from "../../model/SelectListItem";
import { getUsersSelect } from "../../const/getSelectApi";
import { _localization } from "../../config/location";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import DocTypeDeleteView from "./DocType/DocTypeDeleteView";
import DocTypeCreateView from "./DocType/DocTypeCreateView";
import DocTypeEditView from "./DocType/DocTypeEditView";
import { pageTable, repositorySign, styleTable } from "../../_base/_const/_constVar";
import { TblDocTypeModelQuery } from "../../model/TblDocTypeModelQuery";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import { DateInput, DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { ListDocTypeSearchModel } from "../../model/BaseSearchModel";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";

const TypeContractTable = () => {
  // Data and fetching state
  const [data, setData] = useState<TblDocTypeModelQuery[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  // Table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);

  const [dataListUser, setDataListUser] = useState<SelectListItem[]>([]);
  const _span = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);

  const search: ListDocTypeSearchModel = {
    skip: 0,
    take: 0,
  };
  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    try {
      const queryParams: ListDocTypeSearchModel = {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
        keySearch: form.getValues().keySearch,
        CreateDate: form.getValues().CreateDate,
        CreateBy: form.getValues().CreateBy,
        LastUpdateDate: form.getValues().LastUpdateDate,
        UpdateBy: form.getValues().UpdateBy,
        sort: _softing,
        isOrder: sorting.length > 0 ? sorting[0].desc : true,
      };

      const baseUrl = "/api/v1/TblDocType/get-list";
      const queryString = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            const stringValue =
              value instanceof Date ? value.toISOString() : value.toString();
            return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
          }
          return acc;
        }, "")
        .replace(/^&/, "");
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;
      const response = await repositorySign.get<
        MessageResponse<TblDocTypeModelQuery[]>
      >(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
        setDataUpdated(true);
        // await dataOrderTypeSelect();
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  useEffect(() => {
    fetchDataEmployee();
  }, []);

  const fetchDataEmployee = async () => {
    const dataApi = await getUsersSelect();

    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item: any) => item.text !== null);
      setDataListUser(filteredData);
    }
  };

  const usersMap = useMemo(() => {
    const map = new Map<number, string>();
    dataListUser.forEach((user) => {
      map.set(Number(user.value), user.text);
    });
    return map;
  }, [dataListUser]);

  useEffect(() => {
    if (dataUpdated) {
      const updatedData = data.map((item) => ({
        ...item,
        createName: usersMap.get(item.createBy) || "",
        lastUpdateName: usersMap.get(item.lastUpdateBy) || "",
      }));
      setData(updatedData);
      setDataUpdated(false);
    }
  }, [data, dataUpdated, usersMap]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleCreateDocType = () => {
    modals.openConfirmModal({
      title: "Thêm mới loại tài liệu",
      children: <DocTypeCreateView onClose={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleActiveDocType = async ({ status }: { status: boolean }) => {
    if (selectIds.length < 1) {
      NotificationExtension.Info("Vui lòng chọn ít nhất 1 loại tài liệu !");
    } else {
      try {
        let url = "/TblDocType/update-active";

        const response = await repositorySign.post<MessageResponse<boolean>>(
          url,
          {
            ids: selectIds.map((x) => Number(x)),
            status: status,
          }
        );

        if (response && response.success) {
          fetchData();
          NotificationExtension.Success(
            status
              ? "Kích hoạt loại tài liệu thành công !"
              : "Ngừng kích hoạt loại tài liệu thành công !"
          );
        } else {
          NotificationExtension.Fails(
            status
              ? "Kích hoạt loại tài liệu thất bại !"
              : "Ngừng kích hoạt loại tài liệu thất bại !"
          );
        }
      } catch (e) {
        console.error(e);
        return;
      }
    }
  };

  const handleDeleteDoctype = (ids: number[]) => {
    modals.openConfirmModal({
      title: "",
      children: (
        <DocTypeDeleteView
          ids={ids}
          onClose={setOpenModal}
          onSearch={fetchData}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleEditDocType = async (id: number) => {
    modals.openConfirmModal({
      title: "",
      children: <DocTypeEditView id={id} onClose={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  function progessTemplate(props: any): any {
    return (
      <>
        <Tooltip label="Chỉnh sửa">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="cyan"
            onClick={async () => {
              await handleEditDocType(props.id);
            }}
          >
            <IconEdit size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>

        <Tooltip label={props.active === true ? "Dừng hoạt động" : "Hoạt động"}>
          <ActionIcon
            onClick={async () => {
              const url = "/api/v1/TblDocType/active";
              const result = await repositorySign.post<
                MessageResponse<boolean>
              >(url, {
                ids: [props.id],
                status: !props.active,
              });
              if (result && result.httpStatusCode === 200) {
                if (result.success) {
                  await fetchData();
                  NotificationExtension.Success("Thành công !");
                } else
                  NotificationExtension.Fails(
                    result.message.length > 0 ? result.message : "Thất bại !"
                  );
                //   setDisabledBtn(false);
              }
            }}
            variant="light"
            aria-label="Settings"
            color={props.status === true ? "cyan" : "grape"}
          >
            {props.status === true ? (
              <IconLockDown size={14} stroke={1.5} />
            ) : (
              <IconLockOpen size={14} stroke={1.5} />
            )}
          </ActionIcon>
        </Tooltip>

        <Tooltip label="Xóa">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="red"
            onClick={async () => {
              await handleDeleteDoctype([props.id]);
            }}
          >
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  const columns = React.useMemo<MRT_ColumnDef<TblDocTypeModelQuery>[]>(
    () => [
      {
        accessorKey: "id",
        header: "Id",
      },
      {
        accessorKey: "code",
        header: "Mã loại",
      },
      {
        accessorKey: "name",
        header: "Tên tài liệu",
      },
      {
        accessorKey: "description",
        header: "Mô tả",
      },
      {
        accessorKey: "createName",
        header: "Người tạo",
      },
      {
        accessorKey: "lastUpdateName",
        header: "Người cập nhật",
      },
      {
        accessorKey: "active",
        header: " Trạng thái",
        Cell: ({ renderedCellValue }) => (
          <Badge
            variant="light"
            color={renderedCellValue ? "green" : "red"}
            radius={"sm"}
          >
            <Flex>
              {renderedCellValue ? "Đang hoạt động" : "Ngừng hoạt động"}
            </Flex>
          </Badge>
        ),
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "lastUpdateDate",
        header: "Ngày cập nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,

        size: 50,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {progessTemplate(row.original)}
          </Box>
        ),
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: () => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableExpanding: false,
    //  onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: () => ({
      style: styleTable,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex justify="space-between" align="center">
          <BreadcrumbLayout1 />
          <Flex justify={"end"}>
            <div>
              <Button
                leftSection={<IconPlus size={14} />}
                variant="outline"
                mr={"xs"}
                onClick={handleCreateDocType}
              >
                Thêm mới
              </Button>

              <Button
                leftSection={<IconActivity size={14} />}
                color="cyan"
                variant="outline"
                mr={"xs"}
                onClick={async () => {
                  await handleActiveDocType({ status: true });
                }}
                disabled={selectIds.length < 1}
              >
                Sử dụng
              </Button>
              <Button
                leftSection={<IconHandStop size={14} />}
                color="yellow"
                mr={"xs"}
                variant="outline"
                onClick={async () => {
                  await handleActiveDocType({ status: false });
                }}
                disabled={selectIds.length < 1}
              >
                Dừng sử dụng
              </Button>

              <Button
                leftSection={<IconTrash size={14} />}
                color="red"
                variant="outline"
                mr={"xs"}
                onClick={async () => {
                  await handleDeleteDoctype(selectIds as number[]);
                }}
                disabled={selectIds.length < 1}
              >
                Xóa
              </Button>
            </div>
          </Flex>
        </Flex>
        <form>
          <Grid>
            <Grid.Col span={_span}>
              {" "}
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />{" "}
              </Input.Wrapper>
            </Grid.Col>
            <Grid.Col span={_span}>
              <DateInput
                leftSection={<IconCalendar size={14} />}
                valueFormat="DD/MM/YYYY"
                placeholder="Chọn..."
                label="Từ ngày"
                key={form.key(`CreateDate`)}
                {...form.getInputProps("CreateDate")}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <DateInput
                leftSection={<IconCalendar size={14} />}
                valueFormat="DD/MM/YYYY"
                placeholder="Chọn..."
                label="Đến ngày"
                key={form.key(`LastUpdateDate`)}
                {...form.getInputProps("LastUpdateDate")}
                clearable
              />
            </Grid.Col>

            <Grid.Col span={_span}>
              <Select
                label="Người tạo"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataListUser.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                onClick={async () => {
                  if (!dataListUser || dataListUser.length < 1) {
                    await fetchDataEmployee();
                  }
                  return;
                }}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`CreateBy`)}
                {...form.getInputProps("CreateBy")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Người cập nhật"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataListUser.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                onClick={async () => {
                  if (!dataListUser || dataListUser.length < 1) {
                    await fetchDataEmployee();
                  }
                  return;
                }}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`UpdateBy`)}
                {...form.getInputProps("UpdateBy")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              {" "}
              <Button
                mt={"25px"}
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async (e) => {
                  console.log(form.getValues());
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default TypeContractTable;
